import { Injectable, Output, EventEmitter } from '@angular/core';
import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from '@angular/common/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import * as Cookies from 'js-cookie';
import * as momentNs from 'moment';
import { ApiConstant } from '../../utils/api-constant/api-constant.service';
import { NoSpaceValidator } from '../../validator/no-space/no-space.validator';
import { NumericalValidator } from '../../validator/numerical/numerical.validator';
import { MobilePhoneNumberValidator } from '../../validator/mobilephonenumber/mobilephonenumber.validators';
import { RequiredSelectValidator } from '../../validator/required-select/required-select.validator';
import { AlphaNumericalValidator } from '../../validator/alphanumeric/alpha-numeric.validator';
import { EmailValidator } from '../../validator/email/email.validator';
import { AlphabetValidator } from '../../validator/alphabet/alphabet.validator';
import { NoLeadingZeroValidator } from '../../validator/no-leading-zero/no-leading-zero.validator';

const /** @type {?} */ moment = momentNs;

export interface TNKLoanForm {
  form?: FormGroup;
  step: number;
  errors?: any;
  banks: any[];
  birthCities: any[];
  disabledNextButton: boolean;
  serviceAreaIncluded: string;
  actionBusy: boolean;
  provinces: any[];
  cities: any[];
  districts: any[];
  villages: any[];
  postal_codes: any[];
  showStep5Form: boolean;
  PINDataConfirmationBlock: boolean;
  oldVal_dob: string;
  oldVal_gender: string;
  doubleKTP: boolean;
  loadingKTP: boolean;
  cookiesData: any;
  selectedBankName?: string;
  editReviewForm: boolean;
  submitBusy: boolean;
  nextStepBusy: boolean;
  successCallbackURI: string;
  doubleKTPCallbackURI: string;
  errorServerCallbackURI: string;
  busyServerCallbackURI: string;
  stepURI: any[];
  showActionButton: boolean;
  debug: boolean;
  villagesContact: any[];
  citiesContact: any[];
  districtsContact: any[];
  postalCodesContact: any[];
  successTrackerURL: string;
  isReferral: boolean;
  additionalParameter: any;
  errorResponse: string;
  reviewFormError: string;
}
export class B2BTNKLoanFormService {
public data: Observable<TNKLoanForm>;
private dispatcher: BehaviorSubject<TNKLoanForm>;
public store: TNKLoanForm;
private formData: any;
public contactSameAsKTP: boolean;
public currencyOptions: any;
public sameAddressWithKTP: boolean;
/**
 * @param {?} fb
 * @param {?} http
 * @param {?} apiConstant
 * @param {?} router
 */
constructor(
private fb: FormBuilder,
private http: HttpClient,
private apiConstant: ApiConstant,
private router: Router,
  ) {
    this.sameAddressWithKTP = false;
    this.currencyOptions = {
      prefix: '',
      thousands: '.',
      decimal: ',',
      align: 'left',
      precision: 0,
      allowZero: true,
    };

    this.store = {
      banks: [],
      birthCities: [],
      step: 1,
      errors: {
        name: '',
        emailAddress: '',
        mobilePhoneNumber: '',
        mediasource: '',
        pin: '',
        bankName: '',
        bankAccount: '',
        educationType: '',
        ktpName: '',
        birthProvinceId: '',
        birthCityId: '',
        dateOfBirth: '',
        gender: '',
        domicileAddress_street: '',
        domicileAddress_bldNumber: '',
        domicileAddress_flatNumber: '',
        domicileAddress_rt: '',
        domicileAddress_rw: '',
        domicileAddress_province: '',
        domicileAddress_city: '',
        domicileAddress_district: '',
        domicileAddress_village: '',
        domicileAddress_postalCode: '',
        religion: '',
        citizenship: '',
        housing_propertyType: '',
        housing_residentialType: '',
        housing_monthlyCost: '',
        housing_expenseCost: '',
        dependants: '',
        numberOfPeople: '',
        mothersName: '',
        contactAddress_province: '',
        contactAddress_city: '',
        contactAddress_district: '',
        contactAddress_village: '',
        contactAddress_postalCode: '',
        contactAddress_street: '',
        contactAddress_bldNumber: '',
        contactAddress_flatNumber: '',
        contactAddress_rt: '',
        contactAddress_rw: '',
        income_jobType: '',
        income_taxId: '',
        income_employeeId: '',
        income_employmentStatus: '',
        income_employerName: '',
        income_workPosition: '',
        income_monthlyIncome: '',
        income_previousIncome: '',
        maritalStatusType: '',
        spouse_pin: '',
        spouse_name: '',
        spouse_dateOfBirth: '',
        spouse_splitAssetAgreement: '',
        personalReference_name: '',
        personalReference_mobilePhone: '',
        personalReference_homePhone: '',
        personalReference_address: '',
        referralCode: '',
        agreedForm: false,
        loanPurpose: '',
      },
      isReferral: false,
      disabledNextButton: true,
      serviceAreaIncluded: 'null',
      actionBusy: false,
      provinces: [],
      cities: [],
      districts: [],
      villages: [],
      postal_codes: [],
      showStep5Form: false,
      PINDataConfirmationBlock: false,
      oldVal_dob: '',
      oldVal_gender: '',
      doubleKTP: false,
      loadingKTP: true,
      cookiesData: null,
      editReviewForm: false,
      submitBusy: false,
      nextStepBusy: false,
      successCallbackURI: '',
      doubleKTPCallbackURI: '',
      errorServerCallbackURI: '',
      busyServerCallbackURI: '',
      stepURI: [],
      showActionButton: true,
      debug: false,
      villagesContact: [],
      citiesContact: [],
      postalCodesContact: [],
      districtsContact: [],
      successTrackerURL: '',
      additionalParameter: '',
      errorResponse: '',
      reviewFormError: '',
    };

    this.dispatcher = <BehaviorSubject<TNKLoanForm>>new BehaviorSubject({});
    this.data = this.dispatcher.asObservable();
  }
public validationMessages: any = {
    name: {
      required: 'Nama lengkap wajib diisi',
      maxlength: 'Nama lengkap maksimal 50 karakter',
    },
    emailAddress: {
      required: 'Alamat email wajib diisi',
      customEmail: 'Format email tidak sesuai',
      maxlength: 'Alamat email maksimum adalah 50 karakter',
    },
    mobilePhoneNumber: {
      required: 'Nomor handphone wajib diisi',
      numerical: 'Nomor handphone hanya diperbolehkan angka',
      maxlength: 'Nomor handphone maksimal 13 karakter',
      minlength: 'Nomor handphone minimal 10 karakter',
      customMobilePhoneNumber: 'Format Nomor Handphone tidak sesuai',
    },
    mediasource: {
      requiredSelect: 'Sumber media wajib diisi',
    },
    loanPurpose: {
      requiredSelect: 'Tujuan Pinjaman wajib diisi',
    },
    pin: {
      required: 'Nomor KTP wajib diisi',
      numerical: 'Nomor KTP hanya diperbolehkan angka',
      maxlength: 'Nomor KTP maksimal 16 karakter',
      minlength: 'Nomor KTP minimal 16 karakter',
      leadingzeronotallowed: 'Nomor KTP tidak valid',
    },
    bankName: {
      requiredSelect: 'Nama bank wajib diisi',
    },
    bankAccount: {
      required: 'Nomor rekening wajib diisi',
      numerical: 'Nomor rekening hanya diperbolehkan angka',
      minlength: 'Nomor rekening minimal 5 karakter',
      maxlength: 'Nomor rekening maksimal 30 karakter',
    },
    educationType: {
      requiredSelect: 'Pendidikan terakhir wajib diisi',
    },
    ktpName: {
      required: 'Nama sesuai KTP wajib diisi',
      maxlength: 'Nama sesuai KTP maksimal 50 karakter',
      noSpace: 'Nama sesuai KTP tidak boleh diawali spasi',
      requiredSelect: 'Nama sesuai KTP wajib diisi',
      alphabetonly: 'Nama hanya boleh berupa alphabet',
    },
    birthProvinceId: {
      requiredSelect: 'Provinsi tempat kelahiran wajib dipilih',
    },
    birthCityId: {
      requiredSelect: 'Kota tempat kelahiran wajib dipilih',
    },
    dateOfBirth: {
      required: 'Tanggal lahir wajib diisi',
    },
    gender: {
      requiredSelect: 'Jenis kelamin wajib diisi',
    },
    domicileAddress_street: {
      required: 'Alamat KTP wajib diisi',
      maxlength: 'Alamat KTP maksimal 100 karakter',
      minlength: 'Alamat KTP minimal 2 karakter',
      noSpace: 'Alamat KTP tidak boleh diawali spasi',
      requiredSelect: 'Alamat KTP wajib diisi',
    },
    domicileAddress_bldNumber: {
      required: 'Nomor blok wajib diisi',
      maxlength: 'Nomor blok maksimal 5 karakter',
      alphaNumeric: 'Nomor blok tidak diperbolehkan "-"',
    },
    domicileAddress_flatNumber: {
      required: 'Nomor rumah wajib diisi',
      maxlength: 'Nomor rumah maksimal 5 karakter',
      alphaNumeric: 'Nomor rumah tidak diperbolehkan "-"',
    },
    domicileAddress_rt: {
      required: 'RT wajib diisi',
      numerical: 'RT hanya diperbolehkan angka',
      maxlength: 'RT maksimal 3 karakter',
    },
    domicileAddress_rw: {
      required: 'RW wajib diisi',
      numerical: 'RW hanya diperbolehkan angka',
      maxlength: 'RW maksimal 3 karakter',
    },
    domicileAddress_province: {
      requiredSelect: 'Provinsi wajib diisi',
    },
    domicileAddress_city: {
      requiredSelect: 'Kota wajib diisi',
    },
    domicileAddress_district: {
      requiredSelect: 'Kecamatan wajib diisi',
    },
    domicileAddress_village: {
      requiredSelect: 'Kelurahan wajib diisi',
    },
    domicileAddress_postalCode: {
      requiredSelect: 'Kode pos wajib diisi',
    },
    religion: {
      requiredSelect: 'Agama wajib diisi',
    },
    citizenship: {
      requiredSelect: 'Kewarganegaraan wajib diisi',
    },
    housing_propertyType: {
      requiredSelect: 'Jenis tempat tinggal wajib diisi',
    },
    housing_residentialType: {
      requiredSelect: 'Status kepemilikan rumah wajib diisi',
    },
    housing_monthlyCost: {
      required: 'Biaya sewa/cicilan wajib diisi',
      numerical: 'Biaya sewa/cicilan hanya diperbolehkan angka',
      min: 'Biaya sewa/cicilan minimal Rp 100 ribu',
    },
    housing_expenseCost: {
      required: 'Biaya PLN atau PDAM wajib diisi',
      numerical: 'Biaya PLN atau PDAM hanya diperbolehkan angka',
      min: 'Biaya PLN atau PDAM minimal Rp 100 ribu',
    },
    dependants: {
      required: 'Jumlah tanggungan wajib diisi',
      numerical: 'Jumlah tanggungan hanya diperbolehkan angka',
      max: 'Jumlah tanggungan maksimal 15',
    },
    numberOfPeople: {
      required: 'Jumlah orang yg tinggal serumah harus diisi',
      numerical: 'Jumlah orang yg tinggal serumah hanya diperbolehkan angka',
      min: 'Jumlah orang yg tinggal serumah minimal 1',
      max: 'Jumlah orang yg tinggal serumah maksimal 20',
    },
    mothersName: {
      required: 'Nama ibu kandung wajib diisi',
      maxlength: 'Nama ibu kandung maksimal 30 karakter',
      requiredSelect: 'Nama ibu kandung wajib diisi & tidak boleh 0',
      noSpace: 'Nama ibu kandung tidak boleh diawali spasi',
      alphabetonly: 'Nama ibu kandung hanya boleh berupa alphabet',
    },
    contactAddress_street: {
      required: 'Alamat tempat tinggal wajib diisi',
      maxlength: 'Alamat tempat tinggal maksimal 100 karakter',
      minlength: 'Alamat tempat tinggal minimal 2 karakter',
      noSpace: 'Alamat tempat tinggal tidah boleh diawali spasi',
      requiredSelect: 'Alamat tempat tinggal wajib diisi & tidak boleh 0',
    },
    contactAddress_bldNumber: {
      required: 'Nomor blok wajib diisi',
      maxlength: 'Nomor blok maksimal 5 karakter',
      alphaNumeric: 'Nomor blok tidak diperbolehkan "-"',
    },
    contactAddress_flatNumber: {
      required: 'Nomor rumah wajib diisi',
      maxlength: 'Nomor rumah maksimal 5 karakter',
      alphaNumeric: 'Nomor rumah tidak diperbolehkan "-"',
    },
    contactAddress_rt: {
      required: 'RT wajib diisi',
      numerical: 'RT hanya diperbolehkan angka',
      maxlength: 'RT maksimal 3 karakter',
    },
    contactAddress_rw: {
      required: 'RW wajib diisi',
      numerical: 'RW hanya diperbolehkan angka',
      maxlength: 'RW maksimal 3 karakter',
    },
    contactAddress_province: {
      requiredSelect: 'Provinsi wajib diisi',
    },
    contactAddress_city: {
      requiredSelect: 'Kota wajib diisi',
    },
    contactAddress_district: {
      requiredSelect: 'Kecamatan wajib diisi',
    },
    contactAddress_village: {
      requiredSelect: 'Kelurahan wajib diisi',
    },
    contactAddress_postalCode: {
      requiredSelect: 'Kode pos wajib diisi',
    },
    income_jobType: {
      requiredSelect: 'Jenis pekerjaan wajib diisi',
    },
    income_employmentStatus: {
      requiredSelect: 'Status pekerjaan wajib diisi',
    },
    // income_taxId: {
    // 	required: 'Nomor NPWP wajib diisi',
    // 	maxlength: 'Nomor NPWP maksimal 20 karakter',
    // 	numerical: 'Nomor NPWP hanya diperbolehkan angka'
    // },
    // income_employeeId: {
    // 	required: 'Nomor kepegawaian wajib diisi',
    // 	maxlength: 'Nomor kepegawaian maksimal 20 karakter',
    // 	numerical: 'Nomor kepegawaian hanya diperbolehkan angka'
    // },
    income_employerName: {
      required: 'Nama perusahaan wajib diisi',
      maxlength: 'Nama perusahaan maksimal 80 karakter',
      noSpace: 'Nama perusahaan tidak boleh diawali spasi',
      requiredSelect: 'Nama perusahaan wajib diisi & tidak boleh 0',
    },
    income_workPosition: {
      requiredSelect: 'Jabatan di perusahaan wajib diisi',
    },
    income_monthlyIncome: {
      required: 'Penghasilan per bulan wajib diisi',
      numerical: 'Penghasilan per bulan hanya diperbolehkan angka',
      min: 'Penghasilan per bulan minimal Rp 1 juta',
    },
    income_previousIncome: {
      required: 'Penghasilan sebelumnya wajib diisi',
      numerical: 'Penghasilan sebelumnya hanya diperbolehkan angka',
    },
    maritalStatusType: {
      requiredSelect: 'Status pernikahan wajib diisi',
    },
    spouse_pin: {
      numerical: 'Nomor KTP pasangan hanya diperbolehkan angka',
      maxlength: 'Nomor KTP maksimal 16 karakter',
      minlength: 'Nomor KTP minimal 16 karakter',
      required: 'Nomor KTP pasangan wajib diisi',
      leadingzeronotallowed: 'Nomor KTP pasangan tidak valid',
    },
    spouse_name: {
      maxlength: 'Nama pasangan maksimal 50 karakter',
      required: 'Nama pasangan wajib diisi',
      noSpace: 'Nama pasangan tidak boleh diawali spasi',
      requiredSelect: 'Nama pasangan wajib diisi & tidak boleh 0',
      alphabetonly: 'Nama pasangan hanya boleh berupa alphabet',
    },
    spouse_dateOfBirth: {
      required: 'Tanggal lahir pasangan wajib diisi',
    },
    spouse_splitAssetAgreement: {
      required: 'Keterangan harta pasangan wajib dipilih',
    },
    personalReference_name: {
      required: 'Nama referensi wajib diisi',
      maxlength: 'Nama referensi maksimal 30 karakter',
      noSpace: 'Nama referensi tidak boleh diawali spasi',
      requiredSelect: 'Nama referensi wajib diisi & tidak boleh 0',
      alphabetonly: 'Nama referensi hanya boleh berupa alphabet',
    },
    personalReference_mobilePhone: {
      required: 'Nomor handphone referensi wajib diisi',
      numerical: 'Nomor handphone referensi hanya diperbolehkan angka',
      maxlength: 'Nomor handphone maksimal 13 karakter',
      minlength: 'Nomor handphone minimal 10 karakter',
      customMobilePhoneNumber: 'Format Nomor Handphone tidak sesuai',
    },
    // personalReference_homePhone: {
    // 	required: 'Nomor telepon rumah referensi wajib diisi',
    // 	numerical: 'Nomor telepon rumah hanya diperbolehkan angka',
    // 	maxlength: 'Nomor telepon rumah maksimal 14 karakter'
    // },
    personalReference_address: {
      required: 'Alamat referensi wajib diisi',
      maxlength: 'Alamat referensi maksimal 100 karakter',
      minlength: 'Alamat referensi minimal 2 karakter',
    },
    agreedForm: {
      required: 'Persetujuan wajib dipilih',
    },
    referralCode: {
      maxlength: 'Referral Code maksimal 8 karakter',
      minlength: 'Referral Code minimal 8 karakter',
    },
  };
/**
 * @param {?} obj
 * @return {?}
 */
public setStore(obj: any) {
    const /** @type {?} */ tmp = Object.assign(this.store, obj);
    this.dispatcher.next(tmp);
  }
/**
 * @return {?}
 */
public getBank() {
    this.setStore({ actionBusy: true });

    this.http.get(`${this.apiConstant.apiURL}/general/bank`).subscribe(
      (data: any) => {
        this.setStore({ banks: data.result, actionBusy: false });

        // if(this.store.form.controls.bankName.value != '0') {
        // 	this.findBankByCode(this.store.form.controls.bankName.value);
        // }
      },
      (error: HttpErrorResponse) => {
        this.setStore({ banks: [], actionBusy: false });
      },
    );
  }
/**
 * @param {?} str
 * @param {?=} type
 * @return {?}
 */
public getBirthCity(str, type?) {
    this.setStore({ actionBusy: true });

    this.http
      .get(
        `${this.apiConstant.apiURL}/general/region?province=${str}\
			&type=city`,
      )
      .subscribe(
        (data: any) => {
          this.setStore({
            birthCities: data.result,
            actionBusy: false,
          });
          if (!type) {
            this.store.form.patchValue({
              birthCityId: '0',
            });
          }
        },
        (error: HttpErrorResponse) => {
          this.setStore({ birthCities: [], actionBusy: false });
        },
      );
  }
/**
 * @param {?} type
 * @return {?}
 */
public setGender(type) {
    this.store.form.patchValue({ gender: type });

    if (this.store.oldVal_gender === type) {
      this.setStore({ oldVal_gender: type === 'Male' ? 'Female' : 'Male' });
    }

    const { ktpGender } = this.handleGenderAndDob();

    const /** @type {?} */ tmpData = ktpGender === 'L' ? 'Male' : 'Female';
    if (type !== tmpData) {
      this.setStore({
        PINDataConfirmationBlock: true,
      });
    } else {
      this.setStore({
        PINDataConfirmationBlock: false,
      });
    }
  }
/**
 * @return {?}
 */
public handleGenderAndDob(): any {
    const /** @type {?} */ gender = this.formData.oldVal_gender
      ? this.formData.oldVal_gender
      : parseInt(this.store.form.value.pin.substr(6, 1)) < 4
      ? 'L'
      : 'P';

    const /** @type {?} */ ktpGender =
      parseInt(this.store.form.value.pin.substr(6, 1)) < 4 ? 'L' : 'P';

    let /** @type {?} */ birthDate;
    let /** @type {?} */ birthMonth;
    let /** @type {?} */ birthYear;

    if (gender === 'P' || gender === 'Female') {
      birthDate = parseInt(this.store.form.value.pin.substr(6, 2)) + 40;
    } else {
      birthDate = this.store.form.value.pin.substr(6, 2);
    }

    birthMonth = parseInt(this.store.form.value.pin.substr(8, 2)) - 1;
    birthYear = this.store.form.value.pin.substr(10, 2);

    let /** @type {?} */ birthday: any = new Date(birthYear, birthMonth, birthDate);
    const /** @type {?} */ ktpDob = moment(birthday).format('YYYY-MM-DD');

    birthday = this.formData.oldVal_dob
      ? this.formData.oldVal_dob
      : moment(birthday).format('YYYY-MM-DD');

    return {
      gender,
      birthday,
      ktpDob,
      ktpGender,
    };
  }
/**
 * @param {?} data
 * @param {?} type
 * @param {?=} objType
 * @param {?=} onChange
 * @return {?}
 */
public getRegions(data, type, objType?: string, onChange?: boolean) {
    this.setStore({ actionBusy: true });

    switch (type) {
      case 'province': {
        this.http
          .get(`${this.apiConstant.apiURL}/general/region?type=province`)
          .subscribe(
            (data: any) => {
              this.setStore({
                provinces: data.result,
                actionBusy: false,
              });
            },
            (error: HttpErrorResponse) => {
              this.setStore({ actionBusy: false });
            },
          );

        break;
      }

      case 'city': {
        if (!objType && onChange) {
          this.setStore({
            districts: [],
            villages: [],
            postal_codes: [],
          });

          this.store.form.patchValue({
            domicileAddress_city: '0',
            domicileAddress_district: '0',
            domicileAddress_village: '0',
            domicileAddress_postalCode: '0',
          });
        } else if (objType && onChange) {
          this.setStore({
            districtsContact: [],
            villagesContact: [],
            postalCodesContact: [],
          });

          this.store.form.patchValue({
            contactAddress_city: '0',
            contactAddress_district: '0',
            contactAddress_village: '0',
            contactAddress_postalCode: '0',
          });
        }

        this.http
          .get(
            `${this.apiConstant.apiURL}/general/region?province=${data.province}\
					&type=city`,
          )
          .subscribe(
            (data: any) => {
              if (!objType) {
                this.setStore({
                  cities: data.result,
                  actionBusy: false,
                });
              } else {
                this.setStore({
                  citiesContact: data.result,
                  actionBusy: false,
                });
              }
            },
            (error: HttpErrorResponse) => {
              this.setStore({ actionBusy: false });
            },
          );

        break;
      }

      case 'district': {
        if (!objType && onChange) {
          this.setStore({
            villages: [],
            postal_codes: [],
          });

          this.store.form.patchValue({
            domicileAddress_district: '0',
            domicileAddress_village: '0',
            domicileAddress_postalCode: '0',
          });
        } else if (objType && onChange) {
          this.setStore({
            villagesContact: [],
            postalCodesContact: [],
          });

          this.store.form.patchValue({
            contactAddress_district: '0',
            contactAddress_village: '0',
            contactAddress_postalCode: '0',
          });
        }

        this.http
          .get(
            `${this.apiConstant.apiURL}/general/region?province=${data.province}\
					&city=${data.city}&type=district`,
          )
          .subscribe(
            (data: any) => {
              if (!objType) {
                this.setStore({
                  districts: data.result,
                  actionBusy: false,
                });
              } else {
                this.setStore({
                  districtsContact: data.result,
                  actionBusy: false,
                });
              }
            },
            (error: HttpErrorResponse) => {
              this.setStore({ actionBusy: false });
            },
          );

        break;
      }

      case 'village': {
        if (!objType && onChange) {
          this.setStore({ postal_codes: [] });
          this.store.form.patchValue({
            domicileAddress_village: '0',
            domicileAddress_postalCode: '0',
          });
        } else if (objType && onChange) {
          this.setStore({ postalCodesContact: [] });
          this.store.form.patchValue({
            contactAddress_village: '0',
            contactAddress_postalCode: '0',
          });
        }

        this.http
          .get(
            `${this.apiConstant.apiURL}/general/region?province=${data.province}\
					&city=${data.city}&district=${data.district}&type=village`,
          )
          .subscribe(
            (data: any) => {
              if (!objType) {
                this.setStore({
                  villages: data.result,
                  actionBusy: false,
                });
              } else {
                this.setStore({
                  villagesContact: data.result,
                  actionBusy: false,
                });
              }
            },
            (error: HttpErrorResponse) => {
              this.setStore({ actionBusy: false });
            },
          );

        break;
      }

      case 'postal_code': {
        this.http
          .get(
            `${this.apiConstant.apiURL}/general/region?province=${data.province}\
					&city=${data.city}&district=${data.district}&village=${data.village}&type=postal_code`,
          )
          .subscribe(
            (data: any) => {
              if (!objType) {
                this.setStore({
                  postal_codes: data.result,
                  actionBusy: false,
                });

                if (data.result.length === 1) {
                  this.store.form.patchValue({
                    domicileAddress_postalCode: data.result[0].postal_code,
                  });
                }
              } else {
                this.setStore({
                  postalCodesContact: data.result,
                  actionBusy: false,
                });

                if (data.result.length === 1) {
                  this.store.form.patchValue({
                    contactAddress_postalCode: data.result[0].postal_code,
                  });
                }
              }
            },
            (error: HttpErrorResponse) => {
              this.setStore({ actionBusy: false });
            },
          );

        break;
      }
    }
  }
/**
 * @param {?} id
 * @param {?} arr
 * @param {?} type
 * @return {?}
 */
public getRegionName(id: string, arr: any[], type): string {
    if (id !== '0' && arr.length > 0) {
      return arr.filter(item => item[`${type}_id`].toString() === id)[0][
        `${type}`
      ];
    }
  }
/**
 * @param {?} loanAmount
 * @param {?} loanPeriod
 * @return {?}
 */
public calcInitMonthly(loanAmount: number, loanPeriod: number) {
    const /** @type {?} */ monthlyFee = 0;
    const /** @type {?} */ adminFeeAnnual = 540000;
    const /** @type {?} */ interestAnnual = 0.59;
    let /** @type {?} */ monthlyPaymentRaw = 0;
    const /** @type {?} */ ret = [];

    const /** @type {?} */ monthlyInterest = interestAnnual / 12;
    const /** @type {?} */ monthlyAdminFee = adminFeeAnnual / loanPeriod;

    monthlyPaymentRaw =
      loanAmount /
      ((1 - 1 / Math.pow(1.0 + monthlyInterest, loanPeriod)) / monthlyInterest);
    monthlyPaymentRaw += monthlyAdminFee + monthlyFee;

    return monthlyPaymentRaw;
  }
/**
 * @param {?} bool
 * @return {?}
 */
public setDomicileAsContact(bool): void {
    this.sameAddressWithKTP = bool.toString();
    if (bool) {
      this.store.form.patchValue({
        contactAddress_street: this.store.form.value.domicileAddress_street,
        contactAddress_bldNumber: this.store.form.value
          .domicileAddress_bldNumber,
        contactAddress_flatNumber: this.store.form.value
          .domicileAddress_flatNumber,
        contactAddress_rt: this.store.form.value.domicileAddress_rt,
        contactAddress_rw: this.store.form.value.domicileAddress_rw,
        contactAddress_province: this.store.form.value.domicileAddress_province,
        contactAddress_city: this.store.form.value.domicileAddress_city,
        contactAddress_district: this.store.form.value.domicileAddress_district,
        contactAddress_village: this.store.form.value.domicileAddress_village,
        contactAddress_postalCode: this.store.form.value
          .domicileAddress_postalCode,
      });

      this.setStore({
        citiesContact: this.store.cities,
        districtsContact: this.store.districts,
        villagesContact: this.store.villages,
        postalCodesContact: this.store.postal_codes,
      });

      this.setStore({ showStep5Form: false });
      Cookies.set('TNK-FORM5', true);
    } else {
      this.store.form.patchValue({
        contactAddress_street: '',
        contactAddress_bldNumber: '',
        contactAddress_flatNumber: '',
        contactAddress_rt: '',
        contactAddress_rw: '',
        contactAddress_province: '0',
        contactAddress_city: '0',
        contactAddress_district: '0',
        contactAddress_village: '0',
        contactAddress_postalCode: '0',
      });

      if (this.store.provinces.length === 0) {
        this.getRegions({}, 'province');
      }

      this.setStore({ showStep5Form: true });
      Cookies.set('TNK-FORM5', false);
    }
  }
/**
 * @param {?=} ktp
 * @param {?=} cb
 * @return {?}
 */
public checkUserKTP(ktp?: string, cb?: any) {
    const /** @type {?} */ defaultKtp = this.store.form.value.pin
      ? this.store.form.value.pin
      : ktp;

    this.setStore({ loadingKTP: false, disabledNextButton: true });

    this.http
      .get(`${this.apiConstant.apiURL}/user/is-exist?ktp=${defaultKtp}`)
      .subscribe(
        (data: any) => {
          const /** @type {?} */ monthDiff = moment().diff(
            moment(Date.parse(data.result.lastLoanDate)),
            'months',
            true,
          );

          if (
            data.result.exists === 'Y' &&
            (monthDiff < 3 || isNaN(monthDiff))
          ) {
            cb.emit({
              isDouble: true,
              email: this.store.form.value.emailAddress,
              ktp,
            });

            setTimeout(() => {
              this.setStore({
                disabledNextButton: this.stepValidator(1),
                loadingKTP: true,
                doubleKTP: true,
              });
            }, 50);
          } else {
            this.setStore({ doubleKTP: false });

            const /** @type {?} */ doVisitorId = Cookies.get('__do_visitorId');
            const /** @type {?} */ finVisitorId = Cookies.get('__fin_visitorId');
            const /** @type {?} */ bannerId = Cookies.get('__fin_bannerId');
            const /** @type {?} */ refId = Cookies.get('__fin_refId');
            const /** @type {?} */ utmSrc = Cookies.get('__fin_utmSource');

            if (doVisitorId) {
              this.http
                .get(
                  `${this.apiConstant.trackerURLDoAf}/api/tunaiku-com?type=CPL&lead=${defaultKtp}&v=${doVisitorId}`,
                  { responseType: 'text' },
                )
                .subscribe(data => {});
            }

            if (finVisitorId && bannerId && refId && utmSrc) {
              this.http
                .get(
                  `${this.apiConstant.trackerURLFinAf}?&AffiliateID=${refId}&BannerID=${bannerId}&CampaignID=a231cd8b&OrderID=${defaultKtp}&visitorId=${finVisitorId}`,
                )
                .subscribe(data => {});
            }

            // outputting data to execute mixpanel function
            cb.emit({
              isDouble: false,
              email: this.store.form.value.emailAddress,
              ktp,
            });

            setTimeout(() => {
              this.setStore({
                disabledNextButton: this.stepValidator(1),
                loadingKTP: true,
              });
            }, 50);
          }
        },
        (error: HttpErrorResponse) => {
          this.setStore({ doubleKTP: false });
          setTimeout(() => {
            this.setStore({
              disabledNextButton: this.stepValidator(1),
              loadingKTP: true,
            });
          }, 50);
        },
      );
  }
/**
 * @param {?} ktp
 * @param {?} callback
 * @return {?}
 */
private successTrackerRedirection(ktp: string, callback: Function) {
    const /** @type {?} */ doVisitorId = Cookies.get('__do_visitorId');
    const /** @type {?} */ finVisitorId = Cookies.get('__fin_visitorId');
    const /** @type {?} */ bannerId = Cookies.get('__fin_bannerId');
    const /** @type {?} */ refId = Cookies.get('__fin_refId');
    const /** @type {?} */ utmSrc = Cookies.get('__fin_utmSource');
    const /** @type {?} */ lProfId = Cookies.get('__lProf_id');
    const /** @type {?} */ paramId = Cookies.get('__lProf_paramId');

    if (doVisitorId) {
      this.http
        .get(
          `${this.apiConstant.trackerURLDoAf}/api/tunaiku-com?type=CPA&lead=${ktp}&v=${doVisitorId}`,
          {
            responseType: 'text',
          },
        )
        .subscribe(
          (data: any) => {
            return callback(data, null);
          },
          (error: HttpErrorResponse) => {
            return callback(null, error.error);
          },
        );
    } else {
      return callback(null, null);
    }

    if (finVisitorId && bannerId && refId && utmSrc) {
      this.http
        .get(
          `${this.apiConstant.trackerURLFinAf}?&AffiliateID=${refId}&BannerID=${bannerId}&CampaignID=a231cd8b&OrderID=${ktp}&visitorId=${finVisitorId}`,
        )
        .subscribe(data => {});
    } else {
      return callback(null, null);
    }

    if (lProfId && paramId) {
      this.http
        .get(
          `${this.apiConstant.trackerURLLinkProfAf}?&OrderID=${ktp}&ClickHash=${paramId}&CampaignID=d64g9n85&AffiliateID=${lProfId}`,
        )
        .subscribe(data => {});
    } else {
      return callback(null, null);
    }
  }
/**
 * @param {?} ktp
 * @return {?}
 */
private lProfAffTracking(ktp) {
    const /** @type {?} */ lProfId = Cookies.get('__lProf_id');
    const /** @type {?} */ paramId = Cookies.get('__lProf_paramId');

    if (lProfId && paramId) {
      this.http
        .get(
          `${this.apiConstant.trackerURLLinkProfAf}?&OrderID=${ktp}&ClickHash=${paramId}&CampaignID=d64g9n85&AffiliateID=${lProfId}`,
        )
        .subscribe(data => {});
    }
  }
/**
 * @return {?}
 */
private saveFormReview() {
    if (this.isUserPinExist(this.store.form.value.pin)) {
      this.setStore({
        reviewFormError: `Nomor KTP Anda sudah terdaftar di sistem kami. Ajukan pinjaman berikutnya dengan mudah tanpa mengisi semua data lagi
			melalui formulir di akun Anda.`,
      });
    } else {
      const /** @type {?} */ cookiesData = JSON.parse(Cookies.get('TNK-LNDATA'));

      const /** @type {?} */ data = {
        loanAmount: cookiesData.loanAmount.toString(),
        loanPeriodInMonths: cookiesData.loanPeriod.toString(),
        pin: cookiesData.pin.toString(),
        account_bankName: cookiesData.bankName,
        account_accountNumber: cookiesData.bankAccount,
        mobilePhoneNumber: `+62${cookiesData.mobilePhoneNumber}`,
        emailAddress: cookiesData.emailAddress,
        mediaSource: 'Other',
        loanPurposeType: cookiesData.loanPurpose,
      };

      let /** @type {?} */ headers = new HttpHeaders();
      headers = headers.append('access-token', Cookies.get('tracer_token'));

      this.http
        .put(
          `${this.apiConstant.partnerApiURL}/pagetrack/tracer/update`,
          data,
          { headers: headers },
        )
        .subscribe(
          (res: any) => {
            this.setStore({ reviewFormError: '' });
            this.setStore({ editReviewForm: !this.store.editReviewForm });
          },
          (err: HttpErrorResponse) => {
            const /** @type {?} */ errMsg = err.error.data.reason;
            if (errMsg) this.setStore({ reviewFormError: errMsg });
          },
        );
    }
  }
/**
 * @param {?} data
 * @param {?} nextStep
 * @return {?}
 */
private saveLoanDataInEveryStep(data, nextStep) {
    // this.setStore({nextStepBusy: false});
    // this.goToNextStep(nextStep, nextStep - 1);

    let /** @type {?} */ headers = new HttpHeaders();
    headers = headers.append('access-token', Cookies.get('tracer_token'));

    this.http
      .put(
        `${this.apiConstant.partnerApiURL}/pagetrack/tracer/${nextStep}`,
        data,
        { headers: headers },
      )
      .subscribe(
        (res: any) => {
          window.scrollTo(0, 0);
          window.parent.parent.scrollTo(0, 0);

          this.setStore({ errorResponse: '' });
          if (nextStep === 10) {
            this.setStore({ submitBusy: false });
            Cookies.remove('TNK-LNDATA');
            Cookies.remove('TNK-FORM5');
            Cookies.remove('tracer_token');
            Cookies.remove('TNKActiveStep');
            Cookies.remove('savestep1succeed');

            setTimeout(() => {
              location.href = this.store.successCallbackURI;
            }, 100);
          } else {
            this.setStore({ nextStepBusy: false });
            this.goToNextStep(nextStep, nextStep - 1);
          }
        },
        (err: HttpErrorResponse) => {
          this.setStore({ submitBusy: false, nextStepBusy: false });
          const /** @type {?} */ errMsg = err.error.data.reason;
          if (errMsg)
            this.setStore({ errorResponse: errMsg, nextStepBusy: false });
        },
      );
  }
/**
 * @param {?} nextStep
 * @param {?} currStep
 * @return {?}
 */
private goToNextStep(nextStep, currStep) {
    if (this.store.stepURI.length === 0) {
      this.setStore({
        step: nextStep,
        disabledNextButton: this.stepValidator(nextStep),
      });
      Cookies.set('TNKActiveStep', nextStep);
    } else {
      Cookies.set('TNKActiveStep', nextStep);
      this.setStore({
        disabledNextButton: this.stepValidator(nextStep),
      });

      setTimeout(() => {
        // location.href = this.store.stepURI[step];
        this.router.navigateByUrl(this.store.stepURI[currStep]);
        this.setStore({ step: nextStep });
        this.buildForm();
      }, 50);
    }
  }
/**
 * @param {?} pin
 * @return {?}
 */
private isUserPinExist(pin): any {
    this.http
      .get(`${this.apiConstant.apiURL}/user/is-exist?ktp=${pin}`)
      .subscribe(
        (data: any) => {
          const /** @type {?} */ monthDiff = moment().diff(
            moment(Date.parse(data.result.lastLoanDate)),
            'months',
            true,
          );

          if (data.result.exists === 'Y' && monthDiff < 2) {
            return true;
          } else {
            return false;
          }
        },
        (error: HttpErrorResponse) => {
          if (this.store.debug) {
            // tslint:disable-next-line
            console.log('ERROR_POST', error);
          } else {
            if (error.status >= 500) {
              location.href = this.store.errorServerCallbackURI;
            }

            if (error.status >= 400 && error.status < 500) {
              location.href = this.store.busyServerCallbackURI;
            }
          }
        },
      );
  }
/**
 * @param {?} step
 * @param {?} type
 * @return {?}
 */
public stepHandler(step: number, type: string) {
    if (type === 'next') {
      const /** @type {?} */ nextStep: number = step + 1;

      if (step < 9) {
        this.setStore({ nextStepBusy: true });

        if (nextStep === 2) {
          const { gender, birthday } = this.handleGenderAndDob();

          this.setStore({
            oldVal_gender:
              gender === 'L' || gender === 'Male' ? 'Male' : 'Female',
            oldVal_dob: birthday,
          });

          this.store.form.patchValue({
            gender: gender === 'L' || gender === 'Male' ? 'Male' : 'Female',
            dateOfBirth: birthday,
          });

          if (this.isUserPinExist(this.store.form.value.pin)) {
            location.href = this.store.doubleKTPCallbackURI;
          }
        }

        if (nextStep === 3) {
          const /** @type {?} */ lnData = Object.assign({}, Cookies.getJSON('TNK-LNDATA'));
          lnData.oldVal_gender = this.store.form.controls.gender.value;
          lnData.oldVal_dob = this.store.form.controls.dateOfBirth.value;

          Cookies.set('TNK-LNDATA', lnData);
        }

        if (nextStep === 5) {
          if (Cookies.get('TNK-FORM5') === 'true') {
            this.setStore({ showStep5Form: false });
          } else if (Cookies.get('TNK-FORM5') === 'false') {
            this.setStore({ showStep5Form: true });
          }
        }

        const /** @type {?} */ loanData = this.transformReactiveToJSON(this.store.form.value);

        if (nextStep === 3) {
          const /** @type {?} */ birthdayYear = this.store.form.value.dateOfBirth.substring(
            0,
            4,
          );
          const /** @type {?} */ minYearForLoan = new Date().getFullYear() - 80;

          if (birthdayYear < minYearForLoan) {
            this.setStore({
              errorResponse:
                'Umur maksimal untuk melakukan pengajuan pinjaman adalah 80 tahun',
              nextStepBusy: false,
            });
          } else {
            setTimeout(() => {
              this.saveLoanDataInEveryStep(loanData, nextStep);
            }, 200);
          }
        } else {
          setTimeout(() => {
            this.saveLoanDataInEveryStep(loanData, nextStep);
          }, 200);
        }
      } else {
        // submit loan
        this.setStore({ submitBusy: true });

        if (this.store.form.invalid) {
          this.setStore({ submitBusy: false });
          alert('Mohon lengkapi data formulir yang belum diisi');
        } else {
          const /** @type {?} */ loanData = this.transformReactiveToJSON(this.store.form.value);
          setTimeout(() => {
            this.saveLoanDataInEveryStep(loanData, nextStep);
          }, 200);
        }
      }
    } else {
      if (step > 1) {
        const /** @type {?} */ prevStep: number = step - 1;

        this.setStore({
          step: prevStep,
          disabledNextButton: this.stepValidator(prevStep),
        });
        Cookies.set('TNKActiveStep', prevStep);

        if (prevStep === 1) {
          if (
            this.store.errorResponse ===
            'Umur maksimal untuk melakukan pengajuan pinjaman adalah 80 tahun'
          ) {
            this.setStore({ errorResponse: '' });
          }
        }

        if (prevStep === 2) {
          const /** @type {?} */ lnData = Object.assign({}, Cookies.getJSON('TNK-LNDATA'));
          lnData.oldVal_gender = this.store.form.controls.gender.value;
          lnData.oldVal_dob = this.store.form.controls.dateOfBirth.value;

          Cookies.set('TNK-LNDATA', lnData);
        }

        if (this.store.stepURI.length === 0) {
          this.setStore({
            step: prevStep,
            disabledNextButton: this.stepValidator(prevStep),
          });
          Cookies.set('TNKActiveStep', prevStep);
        } else {
          this.setStore({
            disabledNextButton: this.stepValidator(prevStep),
          });
          Cookies.set('TNKActiveStep', prevStep);

          setTimeout(() => {
            // location.href = this.store.stepURI[prevStep-1];
            this.router.navigateByUrl(this.store.stepURI[prevStep - 1]);
            this.setStore({ step: prevStep });
            // this.buzildForm();
          }, 50);
        }
      }
    }
  }
/**
 * @param {?} bool
 * @return {?}
 */
public confirmPINDataChanges(bool) {
    if (this.store.step === 2) {
      if (bool) {
        this.setStore({
          oldVal_gender: this.store.form.value.gender,
          oldVal_dob: this.store.form.value.dateOfBirth,
          PINDataConfirmationBlock: false,
        });
      } else {
        this.setStore({
          PINDataConfirmationBlock: false,
        });

        this.store.form.patchValue({
          gender: this.store.oldVal_gender,
          dateOfBirth: this.store.oldVal_dob,
        });
      }
    }
  }
/**
 * @param {?} status
 * @return {?}
 */
public setServiceArea(status: string) {
    this.setStore({ loadingKTP: false });

    if (status === 'yes') {
      this.setStore({ serviceAreaIncluded: status });
    } else {
      this.setStore({ serviceAreaIncluded: status });
    }

    this.http
      .get(
        `${this.apiConstant.apiURL}/user/is-exist?ktp=${this.store.form.value.pin}`,
      )
      .subscribe(
        (data: any) => {
          const /** @type {?} */ monthDiff = moment().diff(
            moment(Date.parse(data.result.lastLoanDate)),
            'months',
            true,
          );

          if (
            data.result.exists === 'Y' &&
            (monthDiff < 3 || isNaN(monthDiff))
          ) {
            this.setStore({ doubleKTP: true });

            setTimeout(() => {
              this.setStore({
                disabledNextButton: this.stepValidator(1),
                serviceAreaIncluded: status,
                loadingKTP: true,
              });
            }, 50);
          } else {
            this.setStore({ doubleKTP: false });

            setTimeout(() => {
              this.setStore({
                disabledNextButton: this.stepValidator(1),
                serviceAreaIncluded: status,
                loadingKTP: true,
              });
            }, 50);
          }
        },
        (error: HttpErrorResponse) => {
          this.setStore({ doubleKTP: false });

          setTimeout(() => {
            this.setStore({
              disabledNextButton: this.stepValidator(1),
              serviceAreaIncluded: status,
              loadingKTP: true,
            });
          }, 50);
        },
      );
  }
/**
 * @param {?} step
 * @param {?=} type
 * @return {?}
 */
public stepValidator(step: number, type?: string) {
    switch (step) {
      case 1: {
        if (
          this.store.form.controls['pin'].valid &&
          this.store.form.controls['bankName'].valid &&
          this.store.form.controls['bankAccount'].valid &&
          this.store.form.controls['educationType'].valid &&
          this.store.serviceAreaIncluded === 'yes' &&
          !this.store.doubleKTP
        ) {
          return false;
        } else {
          return true;
        }
      }

      case 2: {
        if (
          this.store.form.controls['ktpName'].valid &&
          this.store.form.controls['birthCityId'].valid &&
          this.store.form.controls['dateOfBirth'].valid &&
          this.store.form.controls['gender'].valid
        ) {
          return false;
        } else {
          return true;
        }
      }

      case 3: {
        if (
          this.store.form.controls['domicileAddress_street'].valid &&
          this.store.form.controls['domicileAddress_bldNumber'].valid &&
          this.store.form.controls['domicileAddress_flatNumber'].valid &&
          this.store.form.controls['domicileAddress_rt'].valid &&
          this.store.form.controls['domicileAddress_rw'].valid &&
          this.store.form.controls['domicileAddress_province'].valid &&
          this.store.form.controls['domicileAddress_city'].valid &&
          this.store.form.controls['domicileAddress_district'].valid &&
          this.store.form.controls['domicileAddress_village'].valid &&
          this.store.form.controls['domicileAddress_postalCode'].valid &&
          this.store.form.controls['religion'].valid &&
          this.store.form.controls['citizenship'].valid
        ) {
          return false;
        } else {
          return true;
        }
      }

      case 4: {
        if (
          this.store.form.controls['housing_propertyType'].valid &&
          this.store.form.controls['housing_residentialType'].valid &&
          this.store.form.controls['housing_monthlyCost'].valid &&
          this.store.form.controls['housing_expenseCost'].valid &&
          this.store.form.controls['dependants'].valid &&
          this.store.form.controls['mothersName'].valid &&
          this.store.form.controls['numberOfPeople'].valid
        ) {
          return false;
        } else {
          return true;
        }
      }

      case 5: {
        if (
          this.store.form.controls['contactAddress_street'].valid &&
          this.store.form.controls['contactAddress_bldNumber'].valid &&
          this.store.form.controls['contactAddress_flatNumber'].valid &&
          this.store.form.controls['contactAddress_rt'].valid &&
          this.store.form.controls['contactAddress_rw'].valid &&
          this.store.form.controls['contactAddress_province'].valid &&
          this.store.form.controls['contactAddress_city'].valid &&
          this.store.form.controls['contactAddress_district'].valid &&
          this.store.form.controls['contactAddress_village'].valid &&
          this.store.form.controls['contactAddress_postalCode'].valid
        ) {
          return false;
        } else {
          return true;
        }
      }

      case 6: {
        if (
          this.store.form.value['income_jobType'] !== 'Unemployed' &&
          this.store.form.value['income_jobType'] !== 'Student' &&
          this.store.form.value['income_jobType'] !== 'RetiredPublicServant' &&
          this.store.form.value['income_jobType'] !== 'Retired' &&
          this.store.form.controls['income_jobType'].valid &&
          this.store.form.controls['income_employmentStatus'].valid &&
          this.store.form.controls['income_employerName'].valid &&
          this.store.form.controls['income_workPosition'].valid &&
          this.store.form.controls['income_monthlyIncome'].valid &&
          this.store.form.controls['income_previousIncome'].valid
        ) {
          return false;
        } else if (
          this.store.form.value['income_jobType'] === 'Unemployed' ||
          this.store.form.value['income_jobType'] === 'Student' ||
          this.store.form.value['income_jobType'] === 'RetiredPublicServant' ||
          this.store.form.value['income_jobType'] === 'Retired'
        ) {
          return false;
        } else {
          return true;
        }
      }

      case 7: {
        if (
          this.store.form.value['maritalStatusType'] === 'Married' &&
          this.store.form.controls['maritalStatusType'].valid &&
          this.store.form.controls['spouse_pin'].valid &&
          this.store.form.controls['spouse_name'].valid &&
          this.store.form.controls['spouse_dateOfBirth'].valid &&
          this.store.form.controls['spouse_splitAssetAgreement'].value !== ''
        ) {
          return false;
        } else if (
          this.store.form.controls['maritalStatusType'].value === 'Divorced' ||
          this.store.form.controls['maritalStatusType'].value === 'Single'
        ) {
          return false;
        } else {
          return true;
        }
      }

      case 8: {
        if (
          this.store.form.controls['personalReference_name'].valid &&
          this.store.form.controls['personalReference_mobilePhone'].valid &&
          this.store.form.controls['personalReference_address'].valid
        ) {
          return false;
        } else {
          return true;
        }
      }

      case 9: {
        if (
          this.store.form.controls['pin'].valid &&
          this.store.form.controls['bankName'].valid &&
          this.store.form.controls['bankAccount'].valid &&
          this.store.form.controls['emailAddress'].valid &&
          this.store.form.controls['mobilePhoneNumber'].valid &&
          this.store.form.controls['loanAmount'].value &&
          this.store.form.controls['loanPeriod'].value &&
          this.store.form.controls['loanPurpose'].value !== '0' &&
          this.store.form.controls['agreedForm'].value === true
        ) {
          return false;
        } else {
          return true;
        }
      }
    }
  }
/**
 * @param {?=} cookieService
 * @return {?}
 */
public buildForm(cookieService?): void {
    let /** @type {?} */ form5;
    let /** @type {?} */ refcode;

    try {
      const /** @type {?} */ formData = cookieService.get('TNK-LNDATA');
      this.formData = ( /** @type {?} */((<any>Object))).assign({}, formData);

      this.setStore({ cookiesData: this.formData });

      form5 = cookieService.get('TNK-FORM5');
      refcode = cookieService.get('TNK-REF')
        ? cookieService.get('TNK-REF')
        : formData
        ? formData.referralCode
          ? formData.referralCode
          : ''
        : '';
    } catch ( /** @type {?} */e) {
      const /** @type {?} */ formData = Cookies.getJSON('TNK-LNDATA');
      this.formData = ( /** @type {?} */((<any>Object))).assign({}, formData);

      this.setStore({ cookiesData: this.formData });

      form5 = Cookies.get('TNK-FORM5');
      refcode = Cookies.get('TNK-REF')
        ? Cookies.get('TNK-REF')
        : formData
        ? formData.referralCode
          ? formData.referralCode
          : ''
        : '';
    }

    const /** @type {?} */ group: any = {
      loanAmount: [
        this.formData.loanAmount ? this.formData.loanAmount : null,
        [Validators.required],
      ],
      loanPeriod: [
        this.formData.loanPeriod ? this.formData.loanPeriod : null,
        [Validators.required],
      ],
      emailAddress: [
        this.formData.emailAddress ? this.formData.emailAddress : '',
        [Validators.required, EmailValidator(), Validators.maxLength(50)],
      ],

      mobilePhoneNumber: [
        this.formData.mobilePhoneNumber
          ? this.formData.mobilePhoneNumber.replace('+62', '')
          : '',
        [
          Validators.required,
          NumericalValidator(),
          MobilePhoneNumberValidator(),
          Validators.maxLength(13),
          Validators.minLength(10),
        ],
      ],

      mediasource: [
        this.formData.mediasource ? this.formData.mediasource : '0',
        [RequiredSelectValidator()],
      ],

      loanPurpose: [
        this.formData.loanPurpose ? this.formData.loanPurpose : '0',
        [RequiredSelectValidator()],
      ],
      pin: [
        this.formData.pin ? this.formData.pin : '',
        [
          Validators.required,
          NumericalValidator(),
          Validators.minLength(16),
          Validators.maxLength(16),
          NoLeadingZeroValidator(),
        ],
      ],

      bankName: [
        this.formData.bankName ? this.formData.bankName : '0',
        [RequiredSelectValidator()],
      ],

      bankAccount: [
        this.formData.bankAccount ? this.formData.bankAccount : '',
        [
          Validators.required,
          NumericalValidator(),
          Validators.minLength(5),
          Validators.maxLength(30),
        ],
      ],

      educationType: [
        this.formData.educationType ? this.formData.educationType : '0',
        [RequiredSelectValidator()],
      ],

      ktpName: [
        this.formData.ktpName ? this.formData.ktpName : this.formData.name,
        [
          Validators.required,
          Validators.maxLength(50),
          NoSpaceValidator(),
          RequiredSelectValidator(),
          AlphabetValidator(),
        ],
      ],

      birthProvinceId: [
        this.formData.birthProvinceId ? this.formData.birthProvinceId : '0',
        [RequiredSelectValidator()],
      ],

      birthCityId: [
        this.formData.birthCityId ? this.formData.birthCityId : '0',
        [RequiredSelectValidator()],
      ],

      dateOfBirth: [
        this.formData.dateOfBirth ? this.formData.dateOfBirth : '',
        [Validators.required],
      ],

      gender: [
        this.formData.gender ? this.formData.gender : '',
        [RequiredSelectValidator()],
      ],

      domicileAddress_street: [
        this.formData.domicileAddress_street
          ? this.formData.domicileAddress_street
          : '',
        [
          Validators.required,
          Validators.maxLength(90),
          Validators.minLength(2),
          NoSpaceValidator(),
          RequiredSelectValidator(),
        ],
      ],

      domicileAddress_bldNumber: [
        this.formData.domicileAddress_bldNumber
          ? this.formData.domicileAddress_bldNumber
          : '',
        [
          Validators.required,
          Validators.maxLength(5),
          AlphaNumericalValidator(),
        ],
      ],

      domicileAddress_flatNumber: [
        this.formData.domicileAddress_flatNumber
          ? this.formData.domicileAddress_flatNumber
          : '',
        [
          Validators.required,
          Validators.maxLength(5),
          AlphaNumericalValidator(),
        ],
      ],

      domicileAddress_rt: [
        this.formData.domicileAddress_rt
          ? this.formData.domicileAddress_rt
          : '',
        [Validators.required, Validators.maxLength(3), NumericalValidator()],
      ],

      domicileAddress_rw: [
        this.formData.domicileAddress_rw
          ? this.formData.domicileAddress_rw
          : '',
        [Validators.required, Validators.maxLength(3), NumericalValidator()],
      ],

      domicileAddress_province: [
        this.formData.domicileAddress_province
          ? this.formData.domicileAddress_province
          : '0',
        [RequiredSelectValidator()],
      ],

      domicileAddress_city: [
        this.formData.domicileAddress_city
          ? this.formData.domicileAddress_city
          : '0',
        [RequiredSelectValidator()],
      ],

      domicileAddress_district: [
        this.formData.domicileAddress_district
          ? this.formData.domicileAddress_district
          : '0',
        [RequiredSelectValidator()],
      ],

      domicileAddress_village: [
        this.formData.domicileAddress_village
          ? this.formData.domicileAddress_village
          : '0',
        [RequiredSelectValidator()],
      ],

      domicileAddress_postalCode: [
        this.formData.domicileAddress_postalCode
          ? parseInt(this.formData.domicileAddress_postalCode)
          : '0',
        [RequiredSelectValidator()],
      ],

      religion: [
        this.formData.religion ? this.formData.religion : '0',
        [RequiredSelectValidator()],
      ],

      citizenship: [
        this.formData.citizenship ? this.formData.citizenship : '0',
        [RequiredSelectValidator()],
      ],

      housing_propertyType: [
        this.formData.housing_propertyType
          ? this.formData.housing_propertyType
          : '0',
        [RequiredSelectValidator()],
      ],

      housing_residentialType: [
        this.formData.housing_residentialType
          ? this.formData.housing_residentialType
          : '0',
        [RequiredSelectValidator()],
      ],

      housing_monthlyCost: [
        this.formData.housing_monthlyCost
          ? this.formData.housing_monthlyCost === '0'
            ? '0'
            : parseInt(this.formData.housing_monthlyCost)
          : '',
        [Validators.required, NumericalValidator()],
      ],

      housing_expenseCost: [
        this.formData.housing_expenseCost
          ? this.formData.housing_expenseCost === '0'
            ? '0'
            : parseInt(this.formData.housing_expenseCost)
          : '',
        [Validators.required, NumericalValidator()],
      ],

      dependants: [
        this.formData.dependants
          ? this.formData.dependants === '0'
            ? '0'
            : parseInt(this.formData.dependants)
          : '',
        [Validators.required, NumericalValidator(), Validators.max(15)],
      ],

      numberOfPeople: [
        this.formData.numberOfPeople
          ? parseInt(this.formData.numberOfPeople)
          : '',
        [
          Validators.required,
          NumericalValidator(),
          Validators.min(1),
          Validators.max(20),
        ],
      ],

      mothersName: [
        this.formData.mothersName ? this.formData.mothersName : '',
        [
          Validators.required,
          Validators.maxLength(30),
          NoSpaceValidator(),
          RequiredSelectValidator(),
          AlphabetValidator(),
        ],
      ],

      contactAddress_province: [
        this.formData.contactAddress_province
          ? this.formData.contactAddress_province
          : '0',
        [RequiredSelectValidator()],
      ],

      contactAddress_city: [
        this.formData.contactAddress_city
          ? this.formData.contactAddress_city
          : '0',
        [RequiredSelectValidator()],
      ],

      contactAddress_district: [
        this.formData.contactAddress_district
          ? this.formData.contactAddress_district
          : '0',
        [RequiredSelectValidator()],
      ],

      contactAddress_village: [
        this.formData.contactAddress_village
          ? this.formData.contactAddress_village
          : '0',
        [RequiredSelectValidator()],
      ],

      contactAddress_postalCode: [
        this.formData.contactAddress_postalCode
          ? parseInt(this.formData.contactAddress_postalCode)
          : '0',
        [RequiredSelectValidator()],
      ],

      contactAddress_street: [
        this.formData.contactAddress_street
          ? this.formData.contactAddress_street
          : '',
        [
          Validators.required,
          Validators.maxLength(90),
          Validators.minLength(2),
          NoSpaceValidator(),
          RequiredSelectValidator(),
        ],
      ],

      contactAddress_bldNumber: [
        this.formData.contactAddress_bldNumber
          ? this.formData.contactAddress_bldNumber
          : '',
        [
          Validators.required,
          Validators.maxLength(5),
          AlphaNumericalValidator(),
        ],
      ],

      contactAddress_flatNumber: [
        this.formData.contactAddress_flatNumber
          ? this.formData.contactAddress_flatNumber
          : '',
        [
          Validators.required,
          Validators.maxLength(5),
          AlphaNumericalValidator(),
        ],
      ],

      contactAddress_rt: [
        this.formData.contactAddress_rt ? this.formData.contactAddress_rt : '',
        [NumericalValidator(), Validators.required, Validators.maxLength(3)],
      ],

      contactAddress_rw: [
        this.formData.contactAddress_rw ? this.formData.contactAddress_rw : '',
        [NumericalValidator(), Validators.required, Validators.maxLength(3)],
      ],

      income_jobType: [
        this.formData.income_jobType ? this.formData.income_jobType : '0',
        [RequiredSelectValidator()],
      ],

      // income_taxId: ['', [NumericalValidator(), Validators.maxLength(20), Validators.required]],

      // income_employeeId: ['', [NumericalValidator(), Validators.maxLength(20), Validators.required]],

      income_employmentStatus: [
        this.formData.income_employmentStatus
          ? this.formData.income_employmentStatus
          : '0',
        [RequiredSelectValidator()],
      ],

      income_employerName: [
        this.formData.income_employerName
          ? this.formData.income_employerName
          : '',
        [
          Validators.required,
          Validators.maxLength(80),
          RequiredSelectValidator(),
          NoSpaceValidator(),
        ],
      ],

      income_workPosition: [
        this.formData.income_workPosition
          ? this.formData.income_workPosition
          : '0',
        [RequiredSelectValidator()],
      ],

      income_monthlyIncome: [
        this.formData.income_monthlyIncome
          ? parseInt(this.formData.income_monthlyIncome)
          : '',
        [Validators.required, NumericalValidator(), Validators.min(1000000)],
      ],

      income_previousIncome: [
        this.formData.income_previousIncome
          ? this.formData.income_previousIncome === '0'
            ? '0'
            : parseInt(this.formData.income_previousIncome)
          : '',
        [Validators.required, NumericalValidator()],
      ],

      maritalStatusType: [
        this.formData.maritalStatusType ? this.formData.maritalStatusType : '0',
        [RequiredSelectValidator()],
      ],

      spouse_pin: [
        this.formData.spouse_pin ? this.formData.spouse_pin : '',
        [
          NumericalValidator(),
          Validators.minLength(16),
          Validators.maxLength(16),
        ],
      ],

      spouse_name: [
        this.formData.spouse_name ? this.formData.spouse_name : '',
        [Validators.maxLength(50), AlphabetValidator()],
      ],

      spouse_dateOfBirth: [
        this.formData.spouse_dateOfBirth
          ? this.formData.spouse_dateOfBirth
          : '',
      ],

      spouse_splitAssetAgreement: [
        this.formData.spouse_splitAssetAgreement
          ? this.formData.spouse_splitAssetAgreement
          : '',
      ],

      personalReference_name: [
        this.formData.personalReference_name
          ? this.formData.personalReference_name
          : '',
        [
          Validators.required,
          Validators.maxLength(30),
          NoSpaceValidator(),
          RequiredSelectValidator(),
          AlphabetValidator(),
        ],
      ],

      personalReference_mobilePhone: [
        this.formData.personalReference_mobilePhone
          ? this.formData.personalReference_mobilePhone
          : '',
        [
          Validators.required,
          NumericalValidator(),
          MobilePhoneNumberValidator(),
          Validators.maxLength(13),
          Validators.minLength(10),
        ],
      ],

      personalReference_address: [
        this.formData.personalReference_address
          ? this.formData.personalReference_address
          : '',
        [
          Validators.required,
          Validators.maxLength(90),
          Validators.minLength(2),
        ],
      ],

      agreedForm: [false, [Validators.requiredTrue]],

      referralCode: [refcode ? refcode : '', [Validators.maxLength(8)]],
    };

    /**
     ** @description get birthCities helper from birthProvinceId [helper]
     ** @method getBirthCity(string)
     ** @return data<array> loanFormData.birthCities
     */
    if (
      this.formData.birthProvinceId &&
      this.formData.birthProvinceId !== '0'
    ) {
      this.getBirthCity(this.formData.birthProvinceId, 'init');
    }

    /**
     ** @description get pre-fill regions data for contactAddressObj
     ** @method getRegions(data, type, objType)
     ** @return data<array>[]
     */
    if (
      this.formData.domicileAddress_province &&
      this.formData.domicileAddress_province !== '0' &&
      this.store.cities.length === 0
    ) {
      this.getRegions(
        {
          province: this.formData.domicileAddress_province,
        },
        'city',
      );
    }

    if (
      this.formData.domicileAddress_city &&
      this.formData.domicileAddress_city !== '0' &&
      this.store.districts.length === 0
    ) {
      this.getRegions(
        {
          province: this.formData.domicileAddress_province,
          city: this.formData.domicileAddress_city,
        },
        'district',
      );
    }

    if (
      this.formData.domicileAddress_district &&
      this.formData.domicileAddress_district !== '0' &&
      this.store.villages.length === 0
    ) {
      this.getRegions(
        {
          province: this.formData.domicileAddress_province,
          city: this.formData.domicileAddress_city,
          district: this.formData.domicileAddress_district,
        },
        'village',
      );
    }

    if (
      this.formData.domicileAddress_village &&
      this.formData.domicileAddress_village !== '0' &&
      this.store.postal_codes.length === 0
    ) {
      this.getRegions(
        {
          province: this.formData.domicileAddress_province,
          city: this.formData.domicileAddress_city,
          district: this.formData.domicileAddress_district,
          village: this.formData.domicileAddress_village,
        },
        'postal_code',
      );
    }

    /**
     ** @description get pre-fill regions data for domicileAddressObj
     ** @method getRegions(data, type, objType)
     ** @return data<array>[]
     */
    if (
      this.formData.contactAddress_province &&
      this.formData.contactAddress_province !== '0' &&
      this.store.citiesContact.length === 0
    ) {
      this.getRegions(
        {
          province: this.formData.contactAddress_province,
        },
        'city',
        'contact',
      );
    }

    if (
      this.formData.contactAddress_city &&
      this.formData.contactAddress_city !== '0' &&
      this.store.districtsContact.length === 0
    ) {
      this.getRegions(
        {
          province: this.formData.contactAddress_province,
          city: this.formData.contactAddress_city,
        },
        'district',
        'contact',
      );
    }

    if (
      this.formData.contactAddress_district &&
      this.formData.contactAddress_district !== '0' &&
      this.store.villagesContact.length === 0
    ) {
      this.getRegions(
        {
          province: this.formData.contactAddress_province,
          city: this.formData.contactAddress_city,
          district: this.formData.contactAddress_district,
        },
        'village',
        'contact',
      );
    }

    if (
      this.formData.contactAddress_village &&
      this.formData.contactAddress_village !== '0' &&
      this.store.postalCodesContact.length === 0
    ) {
      this.getRegions(
        {
          province: this.formData.contactAddress_province,
          city: this.formData.contactAddress_city,
          district: this.formData.contactAddress_district,
          village: this.formData.contactAddress_village,
        },
        'postal_code',
        'contact',
      );
    }

    const /** @type {?} */ form = this.fb.group(group);

    if (this.formData.oldVal_gender) {
      this.setStore({ oldVal_gender: this.formData.oldVal_gender });
    }

    if (this.formData.oldVal_dob) {
      this.setStore({ oldVal_dob: this.formData.oldVal_dob });
    }

    this.setStore({
      form: form,
      showStep5Form: form5 === 'true' ? false : true,
    });

    if (!this.store.showStep5Form) {
      this.setDomicileAsContact(true);
    }

    setTimeout(() => {
      this.validateJob(this.store.form.value.income_jobType, 'init');

      if (this.formData.maritalStatusType === 'Married') {
        this.spouseValidity(this.formData.maritalStatusType);
      }

      if (
        this.formData.housing_residentialType === 'BoardingHouse' ||
        this.formData.housing_residentialType === 'Contract'
      ) {
        this.validityCost(this.formData.housing_residentialType);
      }

      this.onChangedValue(this.formData);
    }, 500);

    form.valueChanges.subscribe(data => this.onChangedValue(data));
    form.controls['maritalStatusType'].valueChanges.subscribe(data =>
      this.spouseValidity(data),
    );
    form.controls['housing_residentialType'].valueChanges.subscribe(data =>
      this.validityCost(data),
    );
    form.controls['income_jobType'].valueChanges.subscribe(data =>
      this.validateJob(data),
    );
  }
/**
 * @param {?} data
 * @param {?=} type
 * @return {?}
 */
private validateJob(data, type?: any) {
    if (
      data !== 'PublicServant' &&
      data !== 'PrivateEmployee' &&
      data !== 'MilitaryPolice' &&
      data !== 'Entrepreneur' &&
      data !== 'Other'
    ) {
      this.store.form.controls['income_monthlyIncome'].clearValidators();
      this.store.form.controls['income_monthlyIncome'].updateValueAndValidity();

      this.store.form.patchValue({
        income_employmentStatus: 'Contract',
        income_employerName: 'none',
        income_workPosition: 'Contract',
        income_monthlyIncome: '0',
        income_previousIncome: '0',
      });
    } else {
      this.store.form.controls['income_monthlyIncome'].setValidators([
        Validators.required,
        NumericalValidator(),
        Validators.min(1000000),
      ]);
      this.store.form.controls['income_monthlyIncome'].updateValueAndValidity();

      if (type === 'init') {
        if (this.store.form.controls['income_employmentStatus'].value !== '0') {
          this.store.form.patchValue({
            income_employmentStatus: this.formData.income_employmentStatus,
          });
        }

        if (this.store.form.controls['income_employerName'].value) {
          this.store.form.patchValue({
            income_employerName: this.formData.income_employerName,
          });
        }

        if (this.store.form.controls['income_workPosition'].value !== '0') {
          this.store.form.patchValue({
            income_workPosition: this.formData.income_workPosition,
          });
        }

        if (this.store.form.controls['income_monthlyIncome'].value) {
          this.store.form.patchValue({
            income_monthlyIncome: this.formData.income_monthlyIncome,
          });
        }

        if (this.store.form.controls['income_previousIncome'].value) {
          this.store.form.patchValue({
            income_previousIncome: this.formData.income_previousIncome,
          });
        }
      } else {
        this.store.form.patchValue({
          income_employmentStatus: '0',
          income_employerName: '',
          income_workPosition: '0',
          income_monthlyIncome: '',
          income_previousIncome: '',
        });
      }
    }
  }
/**
 * @param {?} data
 * @return {?}
 */
private validityCost(data) {
    if (data === 'BoardingHouse' || data === 'Contract') {
      this.store.form.controls['housing_monthlyCost'].setValidators([
        Validators.required,
        NumericalValidator(),
        Validators.min(100000),
      ]);
      this.store.form.controls['housing_expenseCost'].setValidators([
        Validators.required,
        NumericalValidator(),
        Validators.min(100000),
      ]);
      this.store.form.controls['housing_monthlyCost'].updateValueAndValidity();
      this.store.form.controls['housing_expenseCost'].updateValueAndValidity();

      this.onChangedValue(this.store.form.value);
    } else {
      this.store.form.controls['housing_monthlyCost'].setValidators([
        Validators.required,
        NumericalValidator(),
      ]);
      this.store.form.controls['housing_expenseCost'].setValidators([
        Validators.required,
        NumericalValidator(),
      ]);
      this.store.form.controls['housing_monthlyCost'].updateValueAndValidity();
      this.store.form.controls['housing_expenseCost'].updateValueAndValidity();

      this.onChangedValue(this.store.form.value);
    }
  }
/**
 * @param {?} val
 * @return {?}
 */
private spouseValidity(val) {
    if (val === 'Married') {
      this.store.form.controls['spouse_pin'].setValidators([
        Validators.required,
        NoLeadingZeroValidator(),
        NumericalValidator(),
        Validators.minLength(16),
        Validators.maxLength(16),
      ]);
      this.store.form.controls['spouse_name'].setValidators([
        Validators.required,
        Validators.maxLength(50),
        NoSpaceValidator(),
        RequiredSelectValidator(),
        AlphabetValidator(),
      ]);
      this.store.form.controls['spouse_dateOfBirth'].setValidators([
        Validators.required,
      ]);
      this.store.form.controls['spouse_splitAssetAgreement'].setValidators([
        Validators.required,
      ]);
      this.store.form.controls['spouse_pin'].updateValueAndValidity();
      this.store.form.controls['spouse_name'].updateValueAndValidity();
      this.store.form.controls['spouse_dateOfBirth'].updateValueAndValidity();
      this.store.form.controls[
        'spouse_splitAssetAgreement'
      ].updateValueAndValidity();

      this.onChangedValue(this.store.form.value);
    } else if (val !== 'Married') {
      this.store.form.controls['spouse_pin'].setValidators([
        NumericalValidator(),
        Validators.minLength(16),
        Validators.maxLength(16),
      ]);
      this.store.form.controls['spouse_name'].setValidators([
        Validators.maxLength(50),
      ]);
      this.store.form.controls['spouse_dateOfBirth'].clearValidators();
      this.store.form.controls['spouse_splitAssetAgreement'].clearValidators();
      this.store.form.controls['spouse_pin'].updateValueAndValidity();
      this.store.form.controls['spouse_name'].updateValueAndValidity();
      this.store.form.controls['spouse_dateOfBirth'].updateValueAndValidity();
      this.store.form.controls[
        'spouse_splitAssetAgreement'
      ].updateValueAndValidity();

      const /** @type {?} */ defaultDate = moment()
        .subtract(21, 'years')
        .format('YYYY-MM-DD');

      this.store.form.patchValue({
        spouse_pin: '',
        spouse_name: '',
        spouse_dateOfBirth: defaultDate,
        spouse_splitAssetAgreement: '',
      });

      this.onChangedValue(this.store.form.value);
    }
  }
/**
 * @param {?} data
 * @return {?}
 */
private onChangedValue(data) {
    if (!this.store.form) {
      return;
    }
    const /** @type {?} */ form = this.store.form;
    const /** @type {?} */ errors = this.store.errors;

    const /** @type {?} */ cookiesData = Cookies.get('TNK-LNDATA')
      ? Cookies.getJSON('TNK-LNDATA')
      : {};

    this.setStore({
      disabledNextButton: this.stepValidator(this.store.step),
    });

    const /** @type {?} */ formValue = ( /** @type {?} */((<any>Object))).assign(cookiesData, data);

    const /** @type {?} */ name = formValue.ktpName ? formValue.ktpName.split(/\s+/) : '';

    if (name.length > 0) {
      formValue.firstName = name[0];
      name.splice(0, 1);

      for (let /** @type {?} */ i = 0; i < name.length; i++) {
        if (name[i] === '') {
          name.splice(i, 1);
          i--;
        }
      }

      formValue.lastName = name.length > 0 ? name.join(' ') : '-';
    }

    Cookies.set('TNK-LNDATA', formValue);

    for (const /** @type {?} */ field in this.store.errors) {
      if (this.store.errors.hasOwnProperty(field)) {
        const /** @type {?} */ control = form.get(field);
        this.store.errors[field] = '';

        this.setStore({ errors: this.store.errors });

        if (control && control.dirty && !control.valid) {
          for (const /** @type {?} */ key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              errors[field] = `${this.validationMessages[field][key]} `;
              this.setStore({ errors: errors });
            }
          }
        } else if (
          control &&
          control.invalid &&
          (control.value !== '' && control.value !== '0')
        ) {
          for (const /** @type {?} */ key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              errors[field] = `${this.validationMessages[field][key]} `;
              this.setStore({ errors: errors });
            }
          }
        }
      }
    }
  }
/**
 * @param {?} value
 * @param {?} type
 * @return {?}
 */
public setBirthDate(value, type) {
    const { ktpDob } = this.handleGenderAndDob();

    if (value !== ktpDob && !type) {
      this.setStore({ PINDataConfirmationBlock: true });
    } else {
      this.setStore({ PINDataConfirmationBlock: false });
    }

    if (!type) {
      this.store.form.patchValue({ dateOfBirth: value });
    } else {
      this.store.form.patchValue({ spouse_dateOfBirth: value });
    }
  }
/**
 * @return {?}
 */
public confirmEditReview() {
    // location.href = '/loan/create-account';
    if (this.store.editReviewForm) {
      this.saveFormReview();
    } else {
      this.setStore({ editReviewForm: !this.store.editReviewForm });
    }

    if (!this.store.form.controls.loanAmount.value) {
      this.store.form.patchValue({ loanAmount: 10000000 });
    }

    if (!this.store.form.controls.loanPeriod.value) {
      this.store.form.patchValue({ loanPeriod: 12 });
    }
  }
/**
 * @param {?} type
 * @param {?} data
 * @return {?}
 */
public handleLoanSlider(type, data) {
    if (type === 'amount_period') {
      this.store.form.patchValue({
        loanAmount: data.loanAmount,
        loanPeriod: data.loanPeriod,
      });

      setTimeout(() => {
        this.setStore({
          disabledNextButton: this.stepValidator(this.store.step),
        });
      }, 50);
    } else if (type === 'purpose') {
      this.store.form.patchValue({
        loanPurpose: data,
      });

      setTimeout(() => {
        this.setStore({
          disabledNextButton: this.stepValidator(this.store.step),
        });
      }, 50);
    }
  }
/**
 * @param {?} evt
 * @return {?}
 */
public agreeToFormPrivacy(evt) {
    this.store.form.patchValue({ agreedForm: evt.target.checked });

    setTimeout(() => {
      this.setStore({
        disabledNextButton: this.stepValidator(this.store.step),
      });
    }, 50);
  }
/**
 * @param {?} step
 * @return {?}
 */
public showErrors(step: number) {
    for (const /** @type {?} */ field in this.store.errors) {
      if (this.store.errors.hasOwnProperty(field)) {
        const /** @type {?} */ control = this.store.form.get(field);

        this.store.errors[field] = '';
        this.setStore({ errors: this.store.errors });

        if (this.store.serviceAreaIncluded === 'null') {
          this.setStore({ serviceAreaIncluded: 'notSelected' });
        }

        if (control) {
          for (const /** @type {?} */ key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              this.store.errors[
                field
              ] = `${this.validationMessages[field][key]} `;
              this.setStore({ errors: this.store.errors });
            }
          }
        }
      }
    }
  }
/**
 * @param {?} dataPhoneNumber
 * @return {?}
 */
public transformPhoneNumber(dataPhoneNumber) {
    let /** @type {?} */ phoneNumber;
    if (dataPhoneNumber.substr(0, 1) === '0') {
      phoneNumber = dataPhoneNumber.substr(1, dataPhoneNumber.length - 1);
    } else if (dataPhoneNumber.substr(0, 2) === '62') {
      phoneNumber = dataPhoneNumber.substr(2, dataPhoneNumber.length - 1);
    } else {
      phoneNumber = dataPhoneNumber;
    }
    return phoneNumber;
  }
/**
 * @param {?} data
 * @return {?}
 */
private transformReactiveToJSON(data) {
    const /** @type {?} */ modelObject = {
      // form step 2
      pin: '',
      account_bankName: '',
      account_accountNumber: '',
      account_accountType: 'Personal',
      educationType: '',
      inAreaCoverage: 'true',

      // form step 3
      birthProvinceId: '',
      birthCityId: '',
      dateOfBirth: '',
      gender: '',

      // form step4
      sameAddress: this.sameAddressWithKTP,
      domicileAddressObj_street: '',
      domicileAddressObj_buildingNumber: '',
      domicileAddressObj_flatNumber: '',
      domicileAddressObj_village: '',
      domicileAddressObj_district: '',
      domicileAddressObj_rt: '',
      domicileAddressObj_rw: '',
      domicileAddressObj_province: '',
      domicileAddressObj_postalCode: '',
      domicileAddressObj_city: '',
      religion: '',
      citizenship: '',

      // form step 5
      housing_residentialType: '',
      housing_propertyType: '',
      housing_monthlyResidenceCost: '',
      housing_electricityAndWaterCost: '',
      housing_homePhone: '',
      dependants: '',
      mothersName: '',

      // form step 6
      contactAddress_street: '',
      contactAddress_buildingNumber: '',
      contactAddress_flatNumber: '',
      contactAddress_village: '',
      contactAddress_district: '',
      contactAddress_rt: '',
      contactAddress_rw: '',
      contactAddress_province: '',
      contactAddress_postalCode: '',
      contactAddress_city: '',

      // form step 7
      income_jobType: '',
      income_taxId: '',
      income_employmentStatus: '',
      income_employerName: '',
      income_employerAddress: '',
      income_workPosition: '',
      income_employeeId: '',
      income_monthlyIncome: '0',
      income_previousIncome: '0',

      // form step 8
      maritalStatusType: '',
      spouse_pin: '',
      spouse_name: '',
      spouse_dateOfBirth: '',
      spouse_splitAssetAgreement: '',
      // form step 9
      personalReference_name: '',
      personalReference_address: '',
      personalReference_homePhone: '',
      personalReference_mobilePhone: '',
      // form step 10
      termsAndAggrement: '',

      // otherLoans: [],
      // referralCode: '',
      // documentValidDate: '',
      // mothersPhone: '',
      // partnerPhone: '',
      // familyCardNumber: '',
      // emailIsOwn: 'Personal',
      // loanPurposeType: '',
      // mediaSource: 'Other',
      // vehicles: [],
      // loanAmount: '',
      // loanPeriodInMonths: '',
      // firstName: '',
      // lastName: '',
      // emailAddress: '',
      // mobilePhoneNumber: '',
      // contractStatus: 'Not signed',
      // pageTrack: [],
      // browserName: '',
      // customerIP: '',
      // documents: []
    };

    const /** @type {?} */ transformedObject: any = Object.assign({}, modelObject);

    // transformedObject.loanAmount = data.loanAmount;
    // transformedObject.loanPeriodInMonths = data.loanPeriod;
    // transformedObject.loanPurposeType = data.loanPurpose;
    // transformedObject.mediasource = data.mediasource ? data.mediasource : 'NotDefined';

    // form step2
    transformedObject.pin = data.pin;
    transformedObject.fullName = data.ktpName;
    (transformedObject.account_bankName = data.bankName),
      (transformedObject.account_accountNumber = data.bankAccount),
      (transformedObject.account_accountType = 'Personal');
    transformedObject.educationType = data.educationType;
    // form step 3
    transformedObject.birthProvinceId = data.birthProvinceId;
    transformedObject.birthCityId = data.birthCityId;
    transformedObject.dateOfBirth = data.dateOfBirth;
    transformedObject.gender = data.gender;
    // form step 4

    transformedObject.domicileAddressObj_street = data.domicileAddress_street;
    transformedObject.domicileAddressObj_buildingNumber =
      data.domicileAddress_bldNumber;
    transformedObject.domicileAddressObj_flatNumber =
      data.domicileAddress_flatNumber;
    transformedObject.domicileAddressObj_province =
      data.domicileAddress_province !== '0'
        ? this.getRegionName(
            data.domicileAddress_province,
            this.store.provinces,
            'province',
          )
        : null;
    transformedObject.domicileAddressObj_city =
      data.domicileAddress_city !== '0'
        ? this.getRegionName(
            data.domicileAddress_city,
            this.store.cities,
            'city',
          )
        : null;
    transformedObject.domicileAddressObj_district =
      data.domicileAddress_district !== '0'
        ? this.getRegionName(
            data.domicileAddress_district,
            this.store.districts,
            'district',
          )
        : null;
    transformedObject.domicileAddressObj_village =
      data.domicileAddress_village !== '0'
        ? this.getRegionName(
            data.domicileAddress_village,
            this.store.villages,
            'village',
          )
        : null;
    transformedObject.domicileAddressObj_rt = data.domicileAddress_rt;
    transformedObject.domicileAddressObj_rw = data.domicileAddress_rw;
    transformedObject.domicileAddressObj_postalCode = data.domicileAddress_postalCode.toString();
    transformedObject.religion = data.religion;
    transformedObject.citizenship = data.citizenship;

    // form step 5
    transformedObject.housing_residentialType = data.housing_residentialType;
    transformedObject.housing_propertyType = data.housing_propertyType;
    transformedObject.housing_monthlyResidenceCost = data.housing_monthlyCost.toString();
    transformedObject.housing_electricityAndWaterCost = data.housing_expenseCost.toString();
    transformedObject.housing_homePhone = `+62${data.mobilePhoneNumber}`;
    transformedObject.dependants = data.dependants.toString();
    transformedObject.mothersName = data.mothersName;
    transformedObject.housing_numberOfPeople = data.numberOfPeople.toString();

    // form step 6
    transformedObject.sameAddress = this.sameAddressWithKTP.toString();

    // if(this.sameAddressWithKTP.toString() == "true"){
    // 	transformedObject.domicileAddressObj_street = data.contactAddress_street;
    // 	transformedObject.domicileAddressObj_buildingNumber = data.contactAddress_bldNumber;
    // 	transformedObject.domicileAddressObj_flatNumber = data.contactAddress_flatNumber;
    // 	transformedObject.domicileAddressObj_province = this.getRegionName(data.contactAddress_province, this.store.provinces, 'province');
    // 	transformedObject.domicileAddressObj_city = this.getRegionName(data.contactAddress_city, this.store.cities, 'city');
    // 	transformedObject.domicileAddressObj_district = this.getRegionName(data.contactAddress_district, this.store.districts, 'district');
    // 	transformedObject.domicileAddressObj_village = this.getRegionName(data.contactAddress_village, this.store.villages, 'village');
    // 	transformedObject.domicileAddressObj_rt = data.contactAddress_rt;
    // 	transformedObject.domicileAddressObj_rw = data.contactAddress_rw;
    // 	transformedObject.domicileAddressObj_postalCode = data.contactAddress_postalCode.toString();
    // }
    // else {

    // }
    transformedObject.contactAddress_street = data.contactAddress_street;
    transformedObject.contactAddress_buildingNumber =
      data.contactAddress_bldNumber;
    transformedObject.contactAddress_flatNumber =
      data.contactAddress_flatNumber;
    transformedObject.contactAddress_province =
      data.contactAddress_province !== '0'
        ? this.getRegionName(
            data.contactAddress_province,
            this.store.provinces,
            'province',
          )
        : null;
    transformedObject.contactAddress_city =
      data.contactAddress_city !== '0'
        ? this.getRegionName(
            data.contactAddress_city,
            this.store.citiesContact,
            'city',
          )
        : null;
    transformedObject.contactAddress_district =
      data.contactAddress_district !== '0'
        ? this.getRegionName(
            data.contactAddress_district,
            this.store.districtsContact,
            'district',
          )
        : null;
    transformedObject.contactAddress_village =
      data.contactAddress_village !== '0'
        ? this.getRegionName(
            data.contactAddress_village,
            this.store.villagesContact,
            'village',
          )
        : null;
    transformedObject.contactAddress_rt = data.contactAddress_rt;
    transformedObject.contactAddress_rw = data.contactAddress_rw;
    transformedObject.contactAddress_postalCode = data.contactAddress_postalCode.toString();

    // form step 7
    // console.log('INCOME EMPLOYMENT STATUS: '+ data.income_employmentStatus)
    transformedObject.income_jobType = data.income_jobType;
    transformedObject.income_taxId = '-';
    transformedObject.income_employmentStatus = data.income_employmentStatus;
    transformedObject.income_employerName = data.income_employerName;
    transformedObject.income_employerAddress = '-';
    transformedObject.income_employeeId = '-';
    transformedObject.income_workPosition = data.income_workPosition;
    transformedObject.income_monthlyIncome = data.income_monthlyIncome.toString();
    transformedObject.income_previousIncome = data.income_previousIncome.toString();

    // form step 8
    transformedObject.maritalStatusType = data.maritalStatusType;
    if (data.maritalStatusType === 'Married') {
      (transformedObject.spouse_pin = data.spouse_pin.toString()),
        (transformedObject.spouse_name = data.spouse_name),
        (transformedObject.spouse_dateOfBirth = data.spouse_dateOfBirth),
        (transformedObject.spouse_splitAssetAgreement =
          data.spouse_splitAssetAgreement);
    } else {
      delete transformedObject.spouse_pin;
      delete transformedObject.spouse_name;
      delete transformedObject.spouse_dateOfBirth;
      delete transformedObject.spouse_splitAssetAgreement;
    }
    // form step 9
    transformedObject.personalReference_name = data.personalReference_name;
    transformedObject.personalReference_address =
      data.personalReference_address;
    transformedObject.personalReference_homePhone = '-';
    transformedObject.personalReference_mobilePhone = `+62${data.personalReference_mobilePhone}`;
    // form step 10
    transformedObject.termsAndAggrement = data.agreedForm.toString();

    // const refCode = Cookies.get('TNK-REF') ? Cookies.get('TNK-REF') : null;
    // if (refCode) {
    // 	transformedObject.referralCode = refCode;
    // }

    // if (data.referralCode) {
    // 	transformedObject.referralCode = data.referralCode;
    // } else {
    // 	delete transformedObject.referralCode;
    // }

    // let name = data.ktpName.split(/\s+/);

    // transformedObject.firstName = name[0];
    // name.splice(0, 1);

    // for (let i = 0; i < name.length; i++) {
    // 	if (name[i] == '') {
    // 		name.splice(i, 1);
    // 		i--;
    // 	}
    // }

    // transformedObject.lastName = name.length > 0 ? name.join(' ') : '-';
    // transformedObject.emailAddress = data.emailAddress;

    // const mobilephone = this.transformPhoneNumber(data.mobilePhoneNumber);
    // const referencePhone = this.transformPhoneNumber(data.personalReference_mobilePhone);

    // transformedObject.personalReference.mobilePhone = `+62${referencePhone}`;
    // transformedObject.personalReference.homePhone =  `+62${referencePhone}`;
    // transformedObject.mobilePhoneNumber = `+62${mobilephone}`;

    // if (additionalData) {
    // 	transformedObject.additionalParameters = {
    // 		device: additionalData.device,
    // 		os: additionalData.os,
    // 		browser: additionalData.browser,
    // 		platform: additionalData.platform,
    // 		sendFrom: 'first loan',
    // 		versionName: 'C08'
    // 	};
    // }

    return transformedObject;
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: FormBuilder, },
{type: HttpClient, },
{type: ApiConstant, },
{type: Router, },
];
}

function B2BTNKLoanFormService_tsickle_Closure_declarations() {
/** @type {?} */
B2BTNKLoanFormService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
B2BTNKLoanFormService.ctorParameters;
/** @type {?} */
B2BTNKLoanFormService.prototype.data;
/** @type {?} */
B2BTNKLoanFormService.prototype.dispatcher;
/** @type {?} */
B2BTNKLoanFormService.prototype.store;
/** @type {?} */
B2BTNKLoanFormService.prototype.formData;
/** @type {?} */
B2BTNKLoanFormService.prototype.contactSameAsKTP;
/** @type {?} */
B2BTNKLoanFormService.prototype.currencyOptions;
/** @type {?} */
B2BTNKLoanFormService.prototype.sameAddressWithKTP;
/** @type {?} */
B2BTNKLoanFormService.prototype.validationMessages;
/** @type {?} */
B2BTNKLoanFormService.prototype.fb;
/** @type {?} */
B2BTNKLoanFormService.prototype.http;
/** @type {?} */
B2BTNKLoanFormService.prototype.apiConstant;
/** @type {?} */
B2BTNKLoanFormService.prototype.router;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
